/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return*/

import {
  instance2,
  TYPE_INSTANCE1,
  TYPE_INSTANCE2,
  TYPE_INSTANCE3,
  TYPE_INSTANCE4,
} from "App/constants";
import { fetchData, isNull } from "App/utils/helpers";
import { useState, useEffect } from "react";
import {
  TYPE_SERVICE_BILLING,
  TYPE_SERVICE_MASTER,
  TYPE_SERVICE_REGISTRASI,
  TYPE_SERVICE_WAREHOUSE,
} from "../MenuAccess/helpers";

export const RESET_STATE_USER_ACCESS = {
  role_id: null,
  role_name: "Pilih Role",

  access_code: null,
  access_name: "Pilih Access",

  access_url: "",
  access_type_service: "",
  access_label: "",
  access_value: "",

  user_id: null,
  user_name: "Pilih User",

  table: [],
};

export const groupByUsername = (array) => {
  return array.reduce((result, currentValue) => {
    const check = result.findIndex(
      (object) => object.username === currentValue.username
    );
    if (check !== -1) {
      result[check].access.push({
        id: currentValue.id,
        user_id: currentValue.user_id,
        username: currentValue.username,
        table_id: currentValue.table_id,
        table_name: currentValue.table_name,
      });
    } else {
      result.push({
        username: currentValue.username,
        user_id: currentValue.user_id,
        access: [
          {
            id: currentValue.id,
            user_id: currentValue.user_id,
            username: currentValue.username,
            table_id: currentValue.table_id,
            table_name: currentValue.table_name,
          },
        ],
      });
    }
    return result;
  }, []);
};

export const deleteUserAccessById = async (id) => {
  try {
    await instance2.post(
      "/users_access/delete_users_access",
      {},
      {
        headers: {
          users_access_id: id,
        },
      }
    );
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const useMenuAccess = () => {
  const [state, setState] = useState([]);
  const [list, setList] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await fetchData(TYPE_INSTANCE2, "/access/access/listaccess");
      if (res) {
        const data = [];
        setList(res);
        res.map((item) => {
          return data.push({
            value: item.access_code,
            label: item.access_name,
          });
        });

        setState(data);
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    menuAccessSelect: state,
    menuAccessList: list,
  };
};

export const useUserByRole = (roleID) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await get();
      if (res) {
        const data = [];

        res.map((item) => {
          return data.push({
            value: item.id_user,
            label: item.username,
          });
        });

        setList(data);
      }
    })();
  }, [roleID]); // eslint-disable-line react-hooks/exhaustive-deps

  const get = async () => {
    try {
      if (roleID !== "") {
        const api = await instance2.get("users/listuser_filterrole", {
          headers: {
            role_id: roleID,
          },
        });
        const res = api.data;
        return res.body;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  };

  return list;
};

export const useByAccess = (
  access_url,
  access_type_service,
  access_label,
  access_value,
  except = [],
  user_id
) => {
  const [state, setState] = useState([]);

  const getResponse = async () => {
    if (access_type_service === TYPE_SERVICE_MASTER) {
      const response = await fetchData(TYPE_INSTANCE2, access_url);
      return response;
    } else if (access_type_service === TYPE_SERVICE_REGISTRASI) {
      const response = await fetchData(TYPE_INSTANCE1, access_url);
      return response;
    } else if (access_type_service === TYPE_SERVICE_BILLING) {
      const response = await fetchData(TYPE_INSTANCE3, access_url, "data");
      return response;
    } else if (access_type_service === TYPE_SERVICE_WAREHOUSE) {
      const response = await fetchData(TYPE_INSTANCE4, access_url, "data");
      return response;
    } else {
      return false;
    }
  };

  useEffect(() => {
    (async () => {
      if (isNull(access_type_service) || isNull(access_url)) {
        setState([]);
      } else {
        const res = await getResponse();
        if (res) {
          const data = [];
          res.map((item) => {
            const haveField = except.filter(
              (x) => x.table_id === item[access_value]
            );
            if (haveField.length === 0) {
              return data.push({
                id: "",
                table_id: item[access_value],
                table_name: item[access_label],
              });
            }
          });

          setState(data);
        } else {
          setState([]);
        }
      }
    })();
  }, [access_type_service, access_url, user_id]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    left: state,
    setLeft: setState,
  };
};

export const groupTable = (arr) => {
  const _temp = [];
  arr.map((item) => {
    return _temp.push({
      table_id: item.value,
      table_name: item.label,
    });
  });

  return _temp;
};
